import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { HERO_IMG } from '../../lib/constants';

const Hero = () => {
  return (
    <section className="relative w-full h-[60dvh] md:h-[95dvh] flex items-center justify-center text-center  mt-0 md:mt-10">
      {/* Background Image */}
      <div className="absolute inset-0 -z-10  rounded-none md:rounded-2xl overflow-hidden">
        <Image
          src={HERO_IMG}
          alt="Premium Furniture and Interior Design Solutions"
          fill
          priority
          className="object-cover brightness-70"
        />
      </div>

      {/* Overlay Content */}
      <div className="max-w-3xl mx-auto px-6 text-white flex flex-col items-center justify-center">
        <h1 className="text-4xl md:text-6xl font-medium mb-4 drop-shadow-lg font-serifx">
          Discover Premium Furniture & Bedding
        </h1>
        <p className="text-base md:text-xl max-w-md md:max-w-xl mb-8 opacity-80">
          Experience a uniquely curated selection of furniture, bedding, and home essentials
        </p>
        <Link href="/products">
          <button
            className="
    relative z-10 px-8 py-3 bg-white border-none transition-all rounded-full font-semibold 
    shadow-lg w-[180px] text-gray-800 overflow-hidden
    hover:text-white hover:bg-transparent hover:border-white border-2
    before:content-[''] before:absolute before:inset-0 before:bg-white/20 
    before:backdrop-blur-lg before:opacity-0 hover:before:opacity-100 
    before:transition-all before:duration-300 before:-z-10
  "
          >
            Shop Now
          </button>


        </Link>
      </div>
    </section>
  );
};

export default Hero;
